import { Box, Paper, Stack } from '@dtx-company/design-system/src'
import { DrawerComponent } from '../PageEditor/components/LinkEditDrawer/LinkEditDrawer'
import { FC } from 'react'
import { ManagerCancelButton } from '../../../components/widgets/components/Manager/ManagerCancelButton'
import { useLinkEditDrawerState } from '../PageEditor/components/LinkEditDrawer/LinkEditDrawer.hooks'
import events from '@dtx-company/inter-app/src/event-tracking/events/flowpage'
import styled from 'styled-components'

export const LinkEditSection: FC<{ handleClose?: () => void }> = ({ handleClose }) => {
  const { onDrawerClose, drawerContentState, previewLink } = useLinkEditDrawerState()

  const onCloseDrawer = (): void => {
    onDrawerClose()
    handleClose?.()
  }

  const cancelEdits = (): void => {
    onCloseDrawer()
    events.Flowpage_PageProfile_Clicked_CancelLinkEdits()
  }

  return (
    <Paper sx={{ width: '100%' }}>
      <Stack>
        <Box sx={{ alignSelf: 'end' }}>
          {drawerContentState && <ManagerCancelButton onClick={cancelEdits} />}
        </Box>

        <DrawerComponent
          type={drawerContentState}
          handleClose={onCloseDrawer}
          currentEditLink={previewLink}
        />
        <LinkEditorScrollAnchor id="fp-link-edit-scroll-anchor" />
      </Stack>
    </Paper>
  )
}

const LinkEditorScrollAnchor = styled.div`
  width: 1px;
  height: 1px;
  color: red;
  visiblity: hidden;
  position: absolute;
  z-index: 100;
  top: -80px;
`
